<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__seal}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
      <el-form-item>
        <!-- <el-input v-model="searchObj.name" placeholder="讲师" /> -->
        <!-- trigger-on-focus参数false一点击不会触发等你输完关键字才会触发true点击就会触发 -->
        <!-- <el-col :span="24">
          <el-autocomplete
            v-model="dataForm.custName"
            class="inline-input"
            :fetch-suggestions="querySearch"
            placeholder="资金方"
            :trigger-on-focus="false"
            value-key="cust_name"
          />
        </el-col> --> 
        <el-select v-model="dataForm.uid" filterable clearable placeholder="资金方">
           <el-option v-for="(item,index) in  fundList" :key="index" :value="item.userId" :label="item.deptName"></el-option>
         </el-select>
      </el-form-item>
        <el-form-item>
          <!-- <el-input
            v-model="dataForm.sealId"
            placeholder="印章id"
            clearable
          ></el-input> -->
          <el-select v-model="dataForm.sealId" filterable clearable placeholder="印章id">
           <el-option v-for="(item,index) in  searchList" :key="index" :value="item.sealId" :label="item.sealId"></el-option>
         </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            v-if="$hasPermission('loan:seal:save')"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border  @selection-change="dataListSelectionChangeHandle" style="width: 100%">
        <el-table-column
          prop="custName"
          label="资金方"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sealId"
          label="印章id"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="修改时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createBy"
          label="操作人"
          header-align="center"
          align="center"
        >
      </el-table-column>
        <el-table-column
          prop="operate"
          label="操作"
          header-align="center"
          align="center"
          
        >
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('loan:seal:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row)"
              >{{ $t("update") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="this.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="this.limit"
        :total="this.total"
        layout="total, sizes, prev, pager, next"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <el-dialog :title="TCapitalSealDto.id ? '修改': '新增'" :visible.sync="dialogFormVisible" @close="clead()">
      <el-form :model="TCapitalSealDto">
        <el-form-item label="资金方" :label-width="formLabelWidth" v-if="TCapitalSealDto.id">
          <el-input v-model="TCapitalSealDto.custName" autocomplete="off" :readonly="true" :class="{ 'disabled-input': TCapitalSealDto.id }">
          </el-input>
        </el-form-item>
        <el-form-item label="资金方" :label-width="formLabelWidth" v-else>
          <!-- <el-input v-model="TCapitalSealDto.custName" autocomplete="off" @input="nameInput" placeholder="请输入姓名">
          </el-input> -->
          <el-select style="width: 100%;" v-model="TCapitalSealDto.uid" filterable clearable placeholder="请输入">
           <el-option v-for="(item,index) in  fundList" :key="index" :value="item.userId" :label="item.deptName"></el-option>
           <!-- <el-option :value="cusFund"  :label="cusFund"></el-option> -->
         </el-select>
        </el-form-item>
        <el-form-item label="原印章ID" :label-width="formLabelWidth" v-if="TCapitalSealDto.id">
          <el-input v-model="this.primevalSealId" autocomplete="off" :readonly="true" :class="{ 'disabled-input': TCapitalSealDto.id }"></el-input>
        </el-form-item>
        <el-form-item :label="TCapitalSealDto.id ? '新印章ID': '印章id'" :label-width="formLabelWidth">
          <el-input v-model="TCapitalSealDto.sealId" autocomplete="off"  @input="newIDInput" :placeholder="TCapitalSealDto.id ? '' :'请输入印章Id'"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clead()">取 消</el-button>
        <el-button type="primary" @click="submint(TCapitalSealDto)">确 定</el-button>
      </div>
    </el-dialog>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/loan/seal/page",
        getDataListIsPage: true,
        deleteURL: '/loan/seal',
        deleteIsBatch: true
      },
      formLabelWidth: '120px',
      dataForm: {
        sealId: "",
        uid: ""
      },
      primevalSealId: '',
      page: 1,
      limit: 10,
      TCapitalSealDto:{},

      dataList: [], // 数据集
      total: 0, //总页数
      dialogFormVisible: false,
      cusFund:null,
      searchList:[],
      fundList:[]

    };
  },

  created(){
    this.getList();
    this.getPerfectInfo();
    this.queryListUser()
  },

  methods:{
    queryListUser(){
      this.$http.get('/sys/user/queryUserIdList').then(res=>{
      if (res.data.code !== 0) {
        return this.$message.error(res.data.msg)
      }
      this.fundList = res.data.data
    })
    },
    getPerfectInfo(){
     
     this.loading = true
    this.$http.post('/loan/transfer/signMessageReturn').then(({data : res}) => {
     this.cusFund = res.data.corporateName
  
   })},
   getList(){
      this.$http
        .get("/loan/seal/page",{params:{
            page: this.page,
            limit: this.limit,
            sealId: this.dataForm.sealId,
            uid: this.dataForm.uid

        }})
        .then(({ data: res }) => {
          if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
          }
          else{
            this.searchList = res.data.list
            this.dataList =res.data.list;
            this.total=res.data.total;
          }
        })
        .catch((error) => {});
    },
    getDataList(){
      this.$http
        .get("/loan/seal/page",{params:{
            page: this.page,
            limit: this.limit,
            sealId: this.dataForm.sealId,
            uid: this.dataForm.uid

        }})
        .then(({ data: res }) => {
          if (res.code !== 0) {
          this.dataList = []
          this.total = 0
          return this.$message.error(res.msg)
          }
          else{
            this.dataList =res.data.list;
            this.total=res.data.total;
          }
        })
        .catch((error) => {});
    },
      submint(TCapitalSealDto){
        if(TCapitalSealDto.id){
          this.$http.put(`/loan/seal/`,TCapitalSealDto).then(({data:res})=>{
              if(res.code!==0){
                return this.$message.error(res.msg)
              }else{
               this.$message({
                message: res.msg,
                type: 'success'
              });
             
              }
          }).catch(()=>{
          }).finally(()=>{
            this.dialogFormVisible=false;
            this.dataForm ={}
            this.getDataList();
          })
        }else{
          this.$http.post(`/loan/seal/`,TCapitalSealDto).then(({data:res})=>{
              if(res.code!==0){
                this.getDataList();
                return this.$message.error(res.msg)
              }else{
                this.$message({
                message: res.msg,
                type: 'success'
              });
              
              }
          }).catch(()=>{
          }).finally(()=>{
            this.dialogFormVisible=false;
            this.dataForm ={}
            this.getDataList();
          })
        }
    },
    addOrUpdateHandle(row){
        if(row){
          this.TCapitalSealDto =row;
          this.primevalSealId =row.sealId;
        }
        this.dialogFormVisible =true;
    },
    clead(){
      this.TCapitalSealDto ={};
      this. dialogFormVisible= false;
    },
    // 每页显示条数改变时触发的方法
    pageSizeChangeHandle(size){
        this.limit=size;
        this.getDataList();
    }
    ,
    // 当前页码改变时触发的方法
    pageCurrentChangeHandle(page) {
      this.page =page;
      this.getDataList();
    },
    // 输入建议
    querySearch(queryString, callBack) {
      const searchText = queryString.trim();
      this.$http
        .get(`/loan/seal/list/name/${searchText}`).then(response=>{
          callBack(response.data.data)
        })
    },
    nameInput(value) {
      const trimmedValue = value.trim();
      this.TCapitalSealDto.custName = trimmedValue;
    },
    newIDInput(value) {
      const trimmedValue = value.trim();
      this.TCapitalSealDto.sealId = trimmedValue;
    },
  }
};

</script>

<style scoped>
 .disabled-input >>> input{
  pointer-events: none; /* 禁止鼠标事件 */
  background-color: #f2f2f2; /* 设置背景颜色为灰色 */
  color: #333; /* 设置文本颜色为黑色 */
}
</style>
